import { Expose } from 'class-transformer';
import { DeviceSetting } from './device-setting';

export class BackLightBrightnessSetting extends DeviceSetting {

    @Expose()
    brightness: number;

    getSettingValue(): Record<string, any> { return { brightness: this.brightness };};

    setSettingValue(value: Record<string, any>): void {
        this.brightness = value?.brightness;
    }
}
